import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "reactstrap";
import SimpleBar from "simplebar-react";

import { determineEntityType } from "common/lib/entityType";
import { searchGlobalContent } from "common/services/search.service";
import { useDispatch } from "react-redux";
import { setSearchValue } from "slices/search/reducer";

const SearchOption = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterData, setFilterData] = useState([]);

  useEffect(() => {
    const searchOptions = document.getElementById(
      "search-close-options"
    ) as HTMLElement;
    const dropdown = document.getElementById("search-dropdown") as HTMLElement;
    const searchInput = document.getElementById(
      "search-options"
    ) as HTMLInputElement;

    const handleSearchInput = () => {
      const inputLength = searchInput.value.length;
      if (inputLength > 0) {
        dropdown.classList.add("show");
        searchOptions.classList.remove("d-none");
      } else {
        dropdown.classList.remove("show");
        searchOptions.classList.add("d-none");
      }
    };

    searchInput.addEventListener("focus", handleSearchInput);
    searchInput.addEventListener("keyup", handleSearchInput);

    searchOptions.addEventListener("click", () => {
      searchInput.value = "";
      setSearchTerm("");
      dropdown.classList.remove("show");
      searchOptions.classList.add("d-none");
    });

    document.body.addEventListener("click", (e: any) => {
      if (e.target.getAttribute("id") !== "search-options") {
        dropdown.classList.remove("show");
        searchOptions.classList.add("d-none");
      }
    });
  }, [searchTerm]);

  const onKeyDownPress = (e: any) => {
    const { key } = e;
    if (key === "Enter") {
      e.preventDefault();
      setSearchTerm(e.target.value);
    }
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setSearchTerm(event.target.value || "");
  };

  useEffect(() => {
    const search = async () => {
      try {
        const response: any = await searchGlobalContent({
          query: searchTerm,
          pageSize: 10,
          page: 1,
        });
        setFilterData(response.hits);
      } catch (error) {}
    };

    search();
  }, [searchTerm]);

  const dispatch: any = useDispatch();

  return (
    <React.Fragment>
      <form
        className="app-search d-none d-md-block"
        style={{ marginLeft: 5, width: "400px" }}
      >
        <div className="position-relative">
          <Input
            type="text"
            className="form-control"
            placeholder="Search..."
            id="search-options"
            value={searchTerm}
            onKeyDown={onKeyDownPress}
            onChange={handleChange}
          />
          <span className="mdi mdi-magnify search-widget-icon"></span>
          <span
            className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
            id="search-close-options"
          ></span>
        </div>
        <div
          className="dropdown-menu dropdown-menu-lg"
          id="search-dropdown"
          style={{ width: "500px" }}
        >
          <SimpleBar style={{ height: "320px" }}>
            <div className="notification-list">
              {filterData.map((data: any, index: number) => {
                const entityType: string = determineEntityType(
                  data._meilisearch_id
                );
                if (entityType === "individual") {
                  return (
                    <Link
                      to={`/individuals/${data?.id}`}
                      className="dropdown-item  notify-item py-2"
                      key={data._meilisearch_id}
                    >
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <h6 className="m-0 text-wrap">{data?.fullName}</h6>
                          <span className="fs-12 mb-0 text-muted">
                            Individual
                          </span>
                        </div>
                      </div>
                    </Link>
                  );
                }
                if (entityType === "mda") {
                  return (
                    <Link
                      to={`/mdas/${data?.id}`}
                      className="dropdown-item  notify-item py-2"
                      key={data._meilisearch_id}
                    >
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <h6 className="m-0 text-wrap">{`${
                            data?.name || ""
                          } - ${data?.region?.name || ""}`}</h6>
                          <span className="fs-12 mb-0 text-muted">
                            {" "}
                            Ministry / Department / Agency
                          </span>
                        </div>
                      </div>
                    </Link>
                  );
                }
                if (entityType === "payment") {
                  return (
                    <Link
                      to={`/payments/${data?.id}`}
                      className="dropdown-item  notify-item py-2"
                      key={data._meilisearch_id}
                    >
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <h6 className="m-0 text-wrap">
                            {`${data?.positionTitle || ""} - ${
                              data?.mda?.name || ""
                            }`}
                          </h6>
                          <span className="fs-12 mb-0 text-muted">
                            Payment / Contract
                          </span>
                        </div>
                      </div>
                    </Link>
                  );
                }
                if (entityType === "agency") {
                  return (
                    <Link
                      to={`/reporting-agencies/${data?.id}`}
                      className="dropdown-item  notify-item py-2"
                      key={data._meilisearch_id}
                    >
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <h6 className="m-0 text-wrap">{data?.name}</h6>
                          <span className="fs-12 mb-0 text-muted">
                            Reporting Agency
                          </span>
                        </div>
                      </div>
                    </Link>
                  );
                }
                if (entityType === "government-request") {
                  return (
                    <Link
                      to={`/government-requests/${data?.id}`}
                      className="dropdown-item  notify-item py-2"
                      key={data._meilisearch_id}
                    >
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <h6 className="m-0 text-wrap">{`${
                            data?.mda?.name || ""
                          }`}</h6>
                          <span className="fs-12 mb-0 text-muted">
                            Government Request
                          </span>
                        </div>
                      </div>
                    </Link>
                  );
                }

                return (
                  <Link
                    to="#"
                    className="dropdown-item notify-item py-2"
                    key={data._meilisearch_id}
                  >
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <h6 className="m-0">Sorry! No Search Results Found</h6>
                        <span className="fs-12 mb-0 text-muted"></span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </SimpleBar>

          <div className="text-center pt-3 pb-1">
            <Link
              to="/search"
              onClick={() => {
                dispatch(setSearchValue(searchTerm));
                setSearchTerm("");
              }}
              className="btn btn-primary btn-sm"
            >
              View All Results <i className="ri-arrow-right-line ms-1"></i>
            </Link>
          </div>
        </div>
      </form>
    </React.Fragment>
  );
};

export default SearchOption;
